import React from 'react';
import css from './Table.module.scss';
import PropTypes from 'prop-types';
import { useTableContext } from './TableContext';

const TableHeader = ({
  width,
  children,
  style,
  align,
  className = '',
  rowSpan,
  colSpan
}) => {
  const {cellAlign} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';

  return (
    <th
      className={`${css.th} ${className}`.trim()}
      style={{ width: width ?? undefined, textAlign: finalAlign, ...style }}
      rowSpan={rowSpan ?? undefined}
      colSpan={colSpan ?? undefined}
    >
      {children}
    </th>
  );
};

TableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.number,
  colSpan: PropTypes.number
};

export default TableHeader;
